import { OdpMonitoringReason, OdpMonitoringResult, OdpMonitoringStage } from 'api';

export const getOdpMonitoringReasonName = (reason: OdpMonitoringReason): string => {
  const reasonNames: Record<OdpMonitoringReason, string> = {
    [OdpMonitoringReason.NewOrInactive]: 'New/Inactive (ODP) Monitoring',
    [OdpMonitoringReason.Psn]: 'PSN (ODP) Monitoring',
    [OdpMonitoringReason.FollowUp]: 'Follow-up Monitoring (ODP) following a NS',
    [OdpMonitoringReason.TransferredExaminer]: 'Transferred Examiner Monitoring (ODP)',
    [OdpMonitoringReason.Other]: 'Other',
  };
  return reasonNames[reason] ?? '-';
};

export const getOdpMonitoringResultName = (result: OdpMonitoringResult): string => {
  const resultNames: Record<OdpMonitoringResult, string> = {
    [OdpMonitoringResult.Standard]: 'Standard',
    [OdpMonitoringResult.NonStandardA]: 'Non-Standard A',
    [OdpMonitoringResult.NonStandardB]: 'Non-Standard B',
  };
  return resultNames[result] ?? '-';
};

export const getOdpMonitoringStageName = (stage: OdpMonitoringStage): string => {
  const stageNames: Record<OdpMonitoringStage, string> = {
    [OdpMonitoringStage.First]: 'First',
    [OdpMonitoringStage.Second]: 'Second',
    [OdpMonitoringStage.Third]: 'Third',
    [OdpMonitoringStage.Fourth]: 'Fourth',
    [OdpMonitoringStage.Fifth]: 'Fifth',
  };
  return stageNames[stage] ?? '-';
};
